import React, { Component } from 'react';
// import logo from './logo.svg';

import '../Geoguide.css';
import 'leaflet/dist/leaflet.css';

import * as firebase from 'firebase';

import $ from 'jquery';
import {Map, TileLayer, Marker, Popup} from 'react-leaflet';

class Others extends Component{
  render(){
    return(
      <div>On ne sait pas encore quoi mettre ici?!</div>
    )
  }
}

export default Others;



// WEBPACK FOOTER //
// ./src/pageComponents/others.js